/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are class periods often 45-50 minutes long?`)
};

const es_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los períodos de clase suelen durar 45-50 minutos?`)
};

const de_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum dauern Unterrichtsstunden oft 45-50 Minuten?`)
};

const nl_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom duren lesuren vaak 45-50 minuten?`)
};

const fr_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les périodes de classe durent-elles souvent 45 à 50 minutes ?`)
};

const it_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le ore di lezione durano spesso 45-50 minuti?`)
};

const pt_br2_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os períodos de classe costumam durar de 45 a 50 minutos?`)
};

const pt_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que os períodos letivos duram muitas vezes 45-50 minutos?`)
};

const ja_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜクラスの時間はよく45〜50分程度なのですか？`)
};

const zh_timer_u45m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么课堂时长通常是45-50分钟？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_faq3_q", locale)
	if (locale === "en") return en_timer_u45m_faq3_q(inputs)
	if (locale === "es") return es_timer_u45m_faq3_q(inputs)
	if (locale === "de") return de_timer_u45m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u45m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u45m_faq3_q(inputs)
	if (locale === "it") return it_timer_u45m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u45m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u45m_faq3_q(inputs)
	return zh_timer_u45m_faq3_q(inputs)
};